export enum PaymentMethod {
  CASH = 'CASH',
  CARD = 'CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
}

export interface SalesTransactionItem {
  id?: number;
  transaction_id?: number;
  product_id: number;
  product_code?: string;
  product_name?: string;
  quantity: number;
  unit_price: number;
  total_price?: number;
}

export interface SalesTransaction {
  id: number;
  transaction_number: string;
  location_id: number;
  sale_date: string; // ISO date (YYYY-MM-DD)
  payment_method: PaymentMethod;
  total_amount: number;
  tax_amount: number;
  discount_amount: number;
  served_by: number;
  created_at: string; // ISO datetime
  updated_at: string; // ISO datetime
  transaction_items: SalesTransactionItem[];
}

export interface SalesFilters {
  start_date?: string; // ISO date
  end_date?: string; // ISO date
  location_id?: number;
  payment_method?: PaymentMethod;
  search?: string;
}